import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import ListAltIcon from "@material-ui/icons/ListAlt";
import MaterialIcon from "../materialIcon/materialIcon";
import { IconButton } from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    minHeight: 516,
    padding: 40,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  titleTwo: {
    fontWeight: "bold",
  },
  icon: {
    color: "#4D8D9D",
    " & .material-icons-outlined": {
      fontSize: 100,
    },
    margin: "auto",
    width: "100%",
  },
}));

const CardDetailNotification = ({ data }) => {
  const classes = useStyles();
  const _ = require("lodash");

  const isEmpty = _.isEmpty(data);
  const getIcon = () => {
    if (data.notificationType === "Requisiciones") {
      return (
        <IconButton className={classes.icon}>
          <MaterialIcon fill="outlined" name={"receipt_long"} />
        </IconButton>
      );
    }
    if (data.notificationType === "Contratos") {
      return (
        <IconButton className={classes.icon}>
          <MaterialIcon fill="outlined" name={"list_alt"} />
        </IconButton>
      );
    }
    if (data.notificationType === "Cumpleaños") {
      return (
        <IconButton className={classes.icon}>
          <MaterialIcon fill="outlined" name={"card_giftcard"} />
        </IconButton>
      );
    }
    if (data.notificationType === "Recomendaciones" || data.notificationType === "Recomendaciones AT") {
      return (
        <IconButton className={classes.icon}>
          <MaterialIcon fill="outlined" name={"rotate_left"} />
        </IconButton>
      );
    }
    if (data.notificationType === "Licencia Maternidad") {
      return (
        <IconButton className={classes.icon}>
          <MaterialIcon fill="outlined" name={"pregnant_woman"} />
        </IconButton>
      );
    }
  };
 
  const getField = () => {
    if (data.notificationType === "Requisiciones") {
      return (
        <Typography className={classes.pos} color="textSecondary">
          {data.message}
        </Typography>
      );
    }
    if (data.notificationType === "Cumpleaños") {
      return (
        <>
          <Typography
            className={classes.pos}
            color="textSecondary"
            variant="h6"
          >
            {data.employeeFullName}
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            Fecha de cumpleaños:{" "}
            {moment(data.birthdayDate).format("DD/MM/YYYY")}
          </Typography>
        </>
      );
    }
    if (data.notificationType === "Contratos") {
      return (
        <>
          <Typography
            className={classes.pos}
            color="textSecondary"
            variant="h6"
          >
            {data.employeeFullName}
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            Fecha finalizacion del contrato:{" "}
            {data.contractEndDate &&
              moment(data.contractEndDate).format("DD/MM/YYYY")}
          </Typography>
        </>
      );
    }
    if (data.notificationType === "Recomendaciones" || data.notificationType === "Recomendaciones AT") {
      return (
        <>
          <Grid container>
            <Grid item xs={12} md={12} lg={12}>
              <Typography
                className={classes.pos}
                color="textSecondary"
                variant="h6"
              >
                Nombre del colaborador
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data.employeeFullName}
              </Typography>
            </Grid>

            <Grid item xs={6} md={6} lg={6}>
              <Typography
                className={classes.pos}
                color="textSecondary"
                variant="h6"
              >
                Cargo:
              </Typography>
            </Grid>

            <Grid item xs={6} md={6} lg={6} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data?.charge}
              </Typography>
            </Grid>

            <Grid item xs={6} md={6} lg={6}>
              <Typography
                className={classes.pos}
                color="textSecondary"
                variant="h6"
              >
                Regional:
              </Typography>
            </Grid>

            <Grid item xs={6} md={6} lg={6} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data?.regional}
              </Typography>
            </Grid>

          </Grid>
          
          <Typography className={classes.pos} color="textSecondary" variant="h6">
            Fecha de final de reintegro por recomendación:{" "}
          </Typography>
          <Typography className={classes.pos} color="textSecondary" >
            {data.refundEndDate && moment(data.refundEndDate).format("DD/MM/YYYY")}
          </Typography>
        </>
      );
    }

    if (data.notificationType === "Licencia Maternidad") {
      return (
        <>
          <Grid container>
            <Grid item xs={12} md={12} lg={12}>
              <Typography
                className={classes.titleTwo}
                color="textSecondary"
              >
                Fecha de Finalización de licencia
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data.maternityLicenceEndDate ? moment(data.maternityLicenceEndDate).format("DD/MM/YYYY") : null}
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Typography
                className={classes.titleTwo}
                color="textSecondary"
              >
                Fecha de inicio de la licencia
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data.maternityLicenseStartDate ? moment(data.maternityLicenseStartDate).format("DD/MM/YYYY") : null}
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Typography
                className={classes.titleTwo}
                color="textSecondary"
              >
                Nombre Completo
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data?.employeeFullName}
              </Typography>
            </Grid>

          </Grid>
          <Grid item xs={12} md={12} lg={12}>
              <Typography
                className={classes.titleTwo}
                color="textSecondary"
              >
                Cargo
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data?.charge}
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Typography
                className={classes.titleTwo}
                color="textSecondary"
              >
                Tipo de contrato
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data?.contractTypeDescription}
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Typography
                className={classes.titleTwo}
                color="textSecondary"
              >
                Regional
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} style={{marginTop: 5}}>
              <Typography
                className={classes.pos}
                color="textSecondary"
              >
                {data?.regional}
              </Typography>
            </Grid>
        </>
      );
    }
  };

  const getEmptyIcon = () => {
    return (
      <IconButton className={classes.icon}>
        <MaterialIcon fill="outlined" name={"search"} />
      </IconButton>
    );
  };

  const getEmptyText = () => {
    return (
      <Typography>
        Haga clic sobre la notificación para ampliar la información.
      </Typography>
    );
  };

  return (
    <Card
      className={classes.root}
      style={{ boxShadow: "3px 3px 2px 1px rgba(0, 0, 0, 0.2)", width: "320px" }}
    >
      <CardContent style={{ height: "auto", overflow: "auto" }}>
        <div style={{ width: "100%" }}>
          {isEmpty ? getEmptyIcon() : getIcon()}
        </div>
        <Typography variant="h5" component="h2" gutterBottom>
          {data.notificationType}
        </Typography>
        {isEmpty ? getEmptyText() : getField()}
      </CardContent>

      <CardActions>
        <Grid container spacing={3}>
          <Grid item container xs={6} justify={"flex-start"}>
            <Typography variant="h7" gutterBottom>
              {moment(data.notificationDate).format("DD/MM/YYYY")}
            </Typography>
          </Grid>
          <Grid item container xs={6} justify={"flex-end"}>
            <Typography variant="h7" gutterBottom>
              {moment(data.notificationDate).format("hh:mm A")}
            </Typography>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default CardDetailNotification;
